import './styles.scss';

export default function StepText({ number, title, className = '' }) {
  return (
    <div className={`StepText d-flex justify-content-start ${className}`}>
      {number && (
        <div>
          <span className="StepText__number">{number}.</span>
        </div>
      )}
      <p className="StepText__title">{title}</p>
    </div>
  );
}
